import { render, staticRenderFns } from "./ModalSuppressAsset.vue?vue&type=template&id=ed058a7c"
import script from "./ModalSuppressAsset.vue?vue&type=script&lang=js"
export * from "./ModalSuppressAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports